/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Archival_HintInputs */



/**
* | output |
* | --- |
* | "Rebuilt from the TWDA, the only remaining record of this event." |
*
* @param {Tournament_Archival_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_archival_hint = /** @type {((inputs?: Tournament_Archival_HintInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Archival_HintInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reconstitué à partir de la TWDA, seule trace restante de ce tournoi.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reconstruido a partir de la TWDA, el único registro que queda de este torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Reconstruído a partir da TWDA, o único registro que restou deste torneio.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricostruito dalla TWDA, l'unica traccia rimasta di questo torneo.")
	return /** @type {LocalizedString} */ ("Rebuilt from the TWDA, the only remaining record of this event.")
});